module.exports = __webpack_public_path__ + "static/media/cost-vs-range-screenshot.2b9992e8.png";